import React, { useEffect , useContext } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 汎用マーカー
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {
  
  const { state } = useContext(Context);

  const icon = menu2icon[option.id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot, option) => {

    let ret = []

    // データセットのリンク表示が必要な場合
    if (option.showDatasetLink) {
      
      // データセット情報の取得
      const dataset = state.data_for_90.data[option.id]

      ret.push(<dl className='dl-list is-modal-spot'><dd><a href={dataset.url} target={"_blank"}>{dataset.dataset_name}</a></dd></dl>)
    }
    
    // 全ての情報を出力する。
    Object.entries(spot).map(entry => {
      // 配列があると落ちるので念の為チェック
      if ( ! Array.isArray(entry[1]) && entry[1] != "") {

        // URLがあればリンクに変更する。
        const label = entry[1].startsWith("http") ? (<a href={entry[1]} target={"_blank"}>{entry[1]}</a>) : entry[1];

        ret.push(<dl className='dl-list is-modal-spot'><dt>{entry[0]}</dt><dd>{label}</dd></dl>)
      }
    })
    
    return ret
  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot, option)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
